import {cs}             from "@Common/react/chain-services";
import {provideContext} from "@Common/react/context";

import {Webchat} from "../common/webchat/webchat";

export const loadWebchat = (next) => cs(
    ["webchat", ({}, next) => Webchat({
        next,
    })],
    ({webchat}) => provideContext({webchat}, next),
);